import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import * as _ from 'lodash';
@Component({
    selector: 'ltms-toast',
    templateUrl: './ltms-toast.component.html',
    styleUrl: './ltms-toast.component.scss',
    standalone: false
})
export class LtmsToastComponent implements OnInit {
  messages:any = []
  constructor(private toastService: ToastService, private router: Router) {}
  ngOnInit(): void {
    let audio: HTMLAudioElement = new Audio('./assets/audio/messagebox.mp3');
   
    this.toastService.messageSubject.subscribe((data)=>{
      if(data){
        this.messages = data;
        audio.play();
        _.each(this.messages,(msg:any,ind:number)=>{
          setTimeout(()=>{
            this.messages[ind].show = true;
          },300)
        })
        this.initTimer(this.messages)
      }
    })
  }
  
  initTimer(messages:any){
    _.each(messages,(msg:any)=>{
      setTimeout(()=>{
       this.removeMessage(msg)
      },msg.duration)
    })
  }

  removeMessage(msg:any){
    this.messages = _.filter(this.messages,(message:any)=>{
      return msg.id != message.id;
    })
    this.toastService.removeMessage(msg)
  }
}